// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordResetSuccess_card__1j10W","description":"PasswordResetSuccess_description__2FMAb"};